import React, { useRef } from 'react'
import { Button, Typography, message } from 'antd'
import { UploadOutlined } from '@ant-design/icons'
import { StateStoredValue } from '../hooks/StoreHooks'
import * as con from "../Constants"
import { RefLanguage } from '../hooks/LanguageHooks'
import { isNullOrUndefined } from '../utils/generalFunctions'
import { processAndSetFinalInputSequence, resetTextInputSequence } from '../store/sequencesActions'

const { Text } = Typography;

function FileUpload() {

    // Store the uploaded file name (content is processed into FINAL_INPUT_SEQUENCE in the largeObjectsDB)
    const [uploadedFile, setUploadedFile] = StateStoredValue(con.UPLOADED_FILE_NAME)
    const fileInputRef = useRef(null)

    const i18n = RefLanguage()

    const handleFileChange = (e) => {
        const file = e.target.files[0]
        if (!file) return

        if (isValidFile(file)) {

            setUploadedFile(file.name)

            const reader = new FileReader();

            reader.onload = async (event) => {
                const fileContent = event.target.result;

                let status = await processAndSetFinalInputSequence(fileContent, con.FILE_INPUT)
                if (status === con.STATUS_OK)
                    resetTextInputSequence()

            };

            reader.onerror = () => {
                message.error(i18n.t("fileReadError"));
            };

            // Read as text 
            reader.readAsText(file);


            // Additional file processing would go here
            message.success(`${file.name} ${i18n.t("uploadSuccess")}`)
        } else {
            message.error(i18n.t("invalidFileFormat"))
        }
    }

    const handleButtonClick = () => {
        fileInputRef.current.click()
    }

    const isValidFile = (file) => {
        // Accepted formats:
        // - FASTA extensions: .fasta, .fas, .fa
        // - Text files: .txt
        // - Files with no extension
        // - Any file with text/plain MIME type
        return (
            !!file &&
            (file.type === '' ||                    // files with no MIME type (often no extension)
                file.type === 'text/plain' ||       // text files including .txt
                file.name.endsWith('.fasta') ||     // FASTAs
                file.name.endsWith('.fas') ||
                file.name.endsWith('.fa') ||
                file.name.endsWith('.txt'))         // text files
        )
    }

    return (
        <div data-tour="file-upload" style={{ textAlign: 'center', marginBottom: '2vh', height: "100%" }}>

            <Typography style={{ marginBottom: "1vh" }}>
                <Text style={{ fontSize: "var(--command-text-size)", fontWeight: "bold" }}>{i18n.t("fileUpload")}</Text>
            </Typography>
            <input
                type="file"
                onChange={handleFileChange}
                style={{ display: 'none' }}
                ref={fileInputRef}
                accept=".fa,.fas,.fasta,.txt,text/plain"
            />
            <Button
                type="primary"
                shape="circle"
                icon={<UploadOutlined />}
                onClick={handleButtonClick}
                size="large"
                style={{
                    height: '100px',
                    width: '100px',
                    fontSize: '32px',
                    backgroundColor: "var(--primary-color-2)"
                }}
            />

            <div style={{ marginTop: '1vh', visibility: !isNullOrUndefined(uploadedFile) ? "visible" : "hidden" }} >
                <Text>{!isNullOrUndefined(uploadedFile) ? uploadedFile : ""}</Text>
            </div>

        </div>
    )
}

export default FileUpload
